import React from "react";
import { Form } from "../../../components/forms";

const ImageUploadGuidelinesPopup = ({ show, onClose }) => {
    const pathwayListItems = [
        "Taken within the last 6 months.",
        "Clear and focused, without blur or red-eye.",
        "Against a plain white background, no other objects or people.",
        "Facing forward, with your face taking up 70-80% of the photo. No hats, sunglasses, or accessories obscuring your face.",
    ];

    if (!show) return null;

    return (
        <Form initialValues={{ message: "" }} enableReinitialize className="d-flex">
            <div className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 popup">
                <div className="bg-white rounded p-4 pb-0 shadow-lg info-inner-box">
                    <div className="d-flex flex-row align-items-center justify-content-between mx-1 mx-md-4">
                        <h5 className="text-primary-600 mb-0 fw-bold">
                            Digital photo guidelines
                        </h5>
                        <button
                            onClick={onClose}
                            className="d-flex bg-transparent border-0 align-items-center"
                        >
                            <img
                                src="/images/vectors/close-circle.svg"
                                alt="close"
                                className="google-icon"
                            />
                        </button>
                    </div>
                    <hr className="hr-popup mt-4 mb-5" />
                    <div className="modal-body mx-1 mx-md-4">
                        <div className="container px-0 d-flex flex-column justify-content-between">

                            <ol className="pathway-list">
                                {pathwayListItems.map((item, index) => (
                                    <li className="mb-2 text-dark-6" key={index}>
                                        {item}
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    );
};

export default ImageUploadGuidelinesPopup;
